import React, { useRef } from "react";
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";

const OrderSummaryCard = ({ singleLessonData, perHourRate }) => {
  const op = useRef(null);

  return (
    <div>
      <Button
        label="Show Order Summary"
        icon="pi pi-info-circle"
        onClick={(e) => op.current.toggle(e)}
        className="p-button-primary"
      />
      <OverlayPanel ref={op} className="p-4 shadow-3">
        <p className="h5 font-semibold color-quaternary text-center">
          Order Summary
        </p>
        <div className="order-summary-section mt-4">
          <div className="d-flex justify-content-between fs-5">
            <span>Total Hours Booked</span>
            <span className="font-weight-bold">
              {singleLessonData?.duration / 60}
            </span>
          </div>
          <hr />
          <div className="d-flex justify-content-between fs-5">
            <span>Lesson Price Per Hour</span>
            <span className="font-weight-bold">£{perHourRate}</span>
          </div>
          <hr />
          <div className="d-flex justify-content-between fs-5">
            <span>Total Amount</span>
            <span className="font-weight-bold">
              £{(singleLessonData?.duration / 60) * perHourRate}
            </span>
          </div>
          <hr />
        </div>
      </OverlayPanel>
    </div>
  );
};

export default OrderSummaryCard;
